// Reads server-sent events from a text stream reader and yields each parsed JSON payload.
// Events split across network reads are buffered until complete.
export async function* streamEvents(reader) {
  let buffer = "";
  const parse = function* (block) {
    const data = block
      .split("\n")
      .filter((line) => line.startsWith("data:"))
      .map((line) => line.slice(5).replace(/^ /, ""))
      .join("\n");
    if (!data) return;
    try {
      yield JSON.parse(data);
    } catch {
      // Ignore anything that isn't JSON
    }
  };

  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += value.replace(/\r\n/g, "\n");
    let end;
    while ((end = buffer.indexOf("\n\n")) !== -1) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      yield* parse(block);
    }
  }
  yield* parse(buffer);
}
